import React from 'react';
import configs from 'configs';
import messages from './messages';
import './styles.scss';
import {FormattedMessage} from 'react-intl';

class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="footer">
        <p>
          <FormattedMessage {...messages.powered} />
          <img src={configs.footerLogo} alt="Logo" className="ml-2"/>
        </p>
        <p>
          <FormattedMessage {...messages.disclaimer} />
        </p>
        <p>
          <a href="https://cdn-generali.ideal-rent.com/ideal/Termini-e-Condizioni-Generali-per-utilizzo-licenza.pdf"
             target="_blank">
            Termini e Condizioni
          </a>&nbsp;|&nbsp;
          <a href="https://cdn-generali.ideal-rent.com/ideal/Informativa-Privacy-Daicar-Rent-NLT-in-Agenzia-Generali.pdf" target="_blank">
            Informativa Privacy
          </a>&nbsp;|&nbsp;
          <a href="https://cdn-generali.ideal-rent.com/ideal/Nomina-Responsabile-Accreditato-DAICAR-RENT.pdf"
             target="_blank">
            Nomina Responsabile
          </a>
        </p>
      </div>
    );
  }
}

export default Footer;
